export { default as Card } from './card';

export type { CardProps, CardVariant } from './card';
